import React from "react";
import SpText from "../atoms/SpText";
import { theme } from "../theme";

const CustomPOIMapMarker = (props) => {
	const { markerData, onClick } = props;
	return (
		<div onClick={onClick}>
			<div style={{ position: "absolute", zIndex: "-1000", width: 0, height: 0, borderLeftWidth: 13, borderRightWidth: 13, borderTopWidth: 30, marginTop: 25, marginLeft: 26, borderStyle: "solid", backgroundColor: "transparent", borderLeftColor: "transparent", borderBottomStyle: "none", borderRightColor: "transparent", borderTopColor: theme.colors.mainGreen.main }}></div>
			<div style={{ maxWidth: 400, height: 50, backgroundColor: theme.colors.mainGreen.main, borderRadius: 40 }}>
				<div style={{ minWidth: 200, height: 40, backgroundColor: theme.colors.mainGreen.main, borderRadius: 40, margin: 5, marginTop: 5, padding: 10 }}>
					<SpText style={{ color: "white", fontSize: "0.7rem" }}>{markerData.title}</SpText>
				</div>
			</div>
		</div>
	);
};

export default CustomPOIMapMarker;
